<template>
  <crud-form
    v-model="payload"
    :request-class="requestClass"
    :page-title="pageTitle"
    :total-group="1"
    navigate-back-route="model.list"
  >
    <template slot="group-1">
      <form-group>
        <v-row>
          <v-col cols="6">
            <input-text
              id="input:nomModeloTerminalPos"
              v-model="payload.nomModeloTerminalPos"
              label="Número do modelo"
              :rules="[requiredRule]"
              outlined
              :loading="loading"
              required
            />
          </v-col>
          <v-col cols="6">
            <v-combobox
              id="input:listIdsTerminalType"
              v-model="payload.listIdsTerminalType"
              label="Número do modelo"
              :rules="[requiredRule]"
              outlined
              :loading="loading"
              required
              multiple
              small-chips
            />
          </v-col>
        </v-row>
      </form-group>
    </template>
  </crud-form>
</template>

<script>
import CrudForm from '@/app/arch/components/crud/CrudForm.vue';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import PosModelRequest from './PosModelRequest';

export default {
  name: 'PosModelForm',
  components: { CrudForm, FormGroup },
  mixins: [RulesMixin],
  data: () => ({
    requestClass: PosModelRequest,
    loading: false,
    payload: {
      nomModeloTerminalPos: '',
      listIdsTerminalType: [],
    },
  }),
  computed: {
    pageTitle() {
      if (this.isEdit) {
        return 'Editar modelo';
      }
      return 'Adicionar modelo';
    },
    isEdit() {
      const { id } = this.$route.params;
      return Number(id) >= 1;
    },
  },
  provide() {
    return {
      setDataLoading: (bool) => {
        this.loading = bool;
      },
    };
  },
};
</script>
